import React from 'react';
import PropTypes from 'prop-types';
import { without } from 'lodash';
import { Tooltip } from 'react-lightweight-tooltip';

const toolTipStyle = {
  wrapper: {
    color: 'inherit',
    cursor: 'default',
  },
  content: {
    background: '#d2d2d2',
    color: '#525252',
    padding: 0,
  },
  tooltip: {
    background: '#d2d2d2',
    borderRadius: '5px',
    marginBottom: 0,
    padding: '4px 1rem',
    bottom: '130%',
  },
  arrow: {
    borderTop: 'solid #d2d2d2 5px',
  },
  gap: {
    width: '45%',
  },
};

const ToolTip = ({ bottom, children, ...props }) => {
  toolTipStyle.tooltip.bottom = bottom;
  return (
    <Tooltip className="tooltip-wrapper" styles={toolTipStyle} {...props}>
      <div className="tooltip-wrapper">{children}</div>
    </Tooltip>
  );
};

ToolTip.defaultProps = {
  bottom: '130%',
};

ToolTip.propTypes = {
  ...without(Tooltip.propTypes, 'styles'),
  bottom: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

ToolTip.displayName = 'ToolTip';

export default ToolTip;



// WEBPACK FOOTER //
// ./src/components/ToolTip.js